import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { forkJoin, Subscription } from 'rxjs';
import { NgbDateStruct, NgbCalendar, NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';

// Service Class
import { CppAddProductSliderModelService } from '../../cpp-common-components/cpp-add-product/cpp-add-product-slider-model.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { CppService } from './../../../../services/cpp/cpp.service';

// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { DialogComponent } from '../../../../common/components/dialog/dialog.component';
import { CppBusinessRuleAnalysisDialogComponent } from '../../cpp-common-components/cpp-business-rule-analysis-dialog/cpp-business-rule-analysis-dialog.component';
import { CommonService } from '../../../../services/common/common.service';
import { SraOrdersService } from '../../../../services/cpp/sra-orders.service';

@Component({
  selector: 'app-sra-error-order-maintenance',
  templateUrl: './sra-error-order-maintenance.component.html',
  styleUrls: ['./sra-error-order-maintenance.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class SraErrorOrderMaintenanceComponent implements OnInit, AfterViewInit, OnDestroy {
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 0;

  // Drop Down Lists Data
  shipToFacilityList: any[];
  soldToFacility: any[];
  deliverToList: any[];
  ddlInstructionTypeList: any[];

  // Header selected values
  shipToAccount: number;
  shipToAccountName: number;
  deliverToAccount: number;
  soldToAccount: number;
  instructionType: string;
  headerCompany = MasterConstants.US_COMPANYCODE;
  specialInstructionText: string;
  purchaseOrder: string;

  sroProductItemsDataSource: any;
  sroOriginalProductItemsDataSource: any;
  itemNoList: any = [];
  displayedColumns: string[]
    = ['checkbox', 'product', 'viewDetail', 'quantity', 'orderUOM', 'packageSize', 'totalGallon', 'deliveryDate'];
  instructionTypeList: Object;
  allChecked = false;
  isCustomerPickup = false;
  isResubmitOrderEnable = false;
  isSaveDeletedItemsEnable = false;

  isAddProductEnable = false;
  showTabs = false;
  tabNode: string;
  editToolKit = false;
  datemodel: NgbDateStruct;
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;

  shipToDataLoading: any;
  soldToDataLoading: any;
  deliverToDataLoading: any;
  disablecheckbox: any;
  selectedCount = 0;
  isSearchClicked: any;
  isReleased: any;
  index: any;
  enable: any;
  dynamicDisclaimerMessage: string;
  webOrderNumber = 0;
  orderId = 0;
  dataChangeSubscription: any;
  hasChangeAdded = false;
  dateFilter: any;
  sub: Subscription;
  filteredDataCount = 0;
  qtyCount = 0;
  totalPrice = 0;
  isNotValid = false;
  accountEmail: string;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  readOnlyAccess = false;
  plAccess = false;
  disclaimerMessage: string;
  itemsToDelete: any = [];
    sroRequestId: any;

  constructor(
    private router: Router,
    private calendar: NgbCalendar,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private sroAddProductSliderModelService: CppAddProductSliderModelService,
    private commonService: CommonService,
    private sraOrdersService: SraOrdersService,
    private cppService: CppService  ) {
    this.dataChangeSubscription = this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    });
  }
  ngOnInit() {
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';
    this.GetDisclaimerMessage();
    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ERROR_ORDER_MAINTENANCE);
    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);

    this.hasChangeAdded = false;
    // this.selectedValue = this.searchTypeList[0];
    this.loadMasterData();
    // this.resetsroItemsFilter();
    this.sroProductItemsDataSource = new MatTableDataSource([]);
    this.sroOriginalProductItemsDataSource = this.sroProductItemsDataSource.data;
    this.disablecheckbox = true;

    this.sub = this.sraOrdersService.sroRequestId.subscribe(([id, flag]) => {
      if (flag) {
        this.orderId = id;
        this.isAddProductEnable = true;
        this.getOrderDetails();
      } else {
        this.router.navigate(['/sro/error/order-maintenance-dashboard']);
      }
    });
    this.sroAddProductSliderModelService.cppModelData.subscribe(x => {
      if (x != null && x.selectedProductList) {
        x.selectedProductList.forEach(x => x.orderQty = 1);
        this.formatNewAddedData(x.selectedProductList);
      }
    });
    this.validateDateFilter();
    this.errorMsgs = new Array();

    // this.sroProductItemsDataSource.filterPredicate = (data: any, filter: any) => {
    //  if (data.itemDescription == null || data.itemDescription == 'undefined') {
    //    data.itemDescription = "";
    //  }
    //  if ((filter.productName == null || filter.productName == undefined || (data.itemDescription.toLowerCase().indexOf(filter.productName.toLowerCase()) > -1))
    //    && (filter.vendor == null || filter.vendor == undefined || (data.itemVendorName && data.itemVendorName.toLowerCase().indexOf(filter.vendor.toLowerCase()) > -1))
    //    && (filter.activeIngredient == null || filter.activeIngredient == undefined || (data.activeIngredient && data.activeIngredient.toLowerCase().indexOf(filter.activeIngredient.toLowerCase()) > -1))
    //    && (filter.packageSize == null || filter.packageSize.length == 0 || (filter.packageSize.indexOf(data.packageSize) > -1))
    //    && (filter.itemNo == null || filter.itemNo.length == 0 || (filter.itemNo.indexOf(data.itemNumber) > -1))) {
    //    this.filteredDataCount = this.filteredDataCount + 1;
    //    this.qtyCount = this.qtyCount + data.quantity;
    //    this.totalPrice = this.totalPrice + (data.quantity * data.price);
    //    return true;
    //  }
    //  else {
    //    return false;
    //  }
    // };
  }

  // Edit Tool kit's Delivery date validations
  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const calendarDate = d;
      // Prevent Saturday and Sunday from being selected.
      return calendarDate >= currentDate; // && calendarDate <= maxDate;
    };
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    const tableHeight = window.innerHeight - 65;
    $('.createCPPOuter').css('height', tableHeight + 'px');
  }


  GetDisclaimerMessage() {
    this.sraOrdersService.GetDisclaimerMessage().subscribe((result: any) => {
      if (result) {
        this.dynamicDisclaimerMessage = result.message;
      }
    });
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    let deliverToAccount: number;
    let soldToAccount: number;

    this.sraOrdersService.getSroEditOrderDetail(this.orderId).subscribe((result: any) => {
      this.webOrderNumber = result.webOrderNumber;
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = result.shipToAccountName;
      deliverToAccount = result.deliverToAccountId;
      soldToAccount = result.soldToAccountId;
      this.purchaseOrder = result.purchaseOrder;
      this.accountEmail = this.accountEmail && result.emailAddress != this.accountEmail ? result.emailAddress + ',' + this.accountEmail : result.emailAddress;
      this.specialInstructionText = result.specialInstruction == null ? '' : result.specialInstruction;
      this.instructionType = result.instructionType;
      this.isCustomerPickup = result.customerPickUp;
      this.formatNewAddedData(result.productList);
      this.sraOrdersService.getDeliverToFacilityList(result.shipToAccountId, result.parentAccountId).subscribe((result: any[]) => {
        this.deliverToList = result;
        this.deliverToAccount = deliverToAccount;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false));

      this.sraOrdersService.getSoldToFacility(result.shipToAccountId).subscribe((result: any[]) => {
        this.soldToFacility = [result];
        this.soldToAccount = soldToAccount;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false));

      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false));
  }

  // formate Data from Add Product Slider Model
  formatNewAddedData(productList: any[]) {
    const orderList = [];
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    let rowId = 0;
    this.sroProductItemsDataSource.data.forEach(x => {
      orderList.push(x);
      if (x.rowId > rowId) { rowId = x.rowId; }
    });
    productList.forEach(x => {
      rowId = rowId + 1;
      const duplicateData = orderList.find(y => y.itemId == x.itemId);
      if (duplicateData == undefined) {
        const newRow = {
          rowId: rowId,
          isSelected: false,
          isProductDetailDisplayed: false,
          itemId: x.itemId,
          itemNumber: x.itemNumber,
          itemDescription: x.itemDescription,
          itemVendorName: x.itemVendorName,
          packageSize: x.packageSize,
          gtin: x.gtin,
          activeIngredient: x.activeIngredient,
          productSegment: x.productSegment,
          productLine: x.productLine,
          palletQuantity: x.palletQuantity,
          programName: x.programName,
          bulkPackaged: x.bulkPackaged,
          vendedProprietary: x.vendedProprietary,
          xrefCheckBK: x.xrefCheckBK,
          itemFlashMsg: x.itemFlashMsg,
          restrictedUse: x.restrictedUse,
          returnable: x.returnable,
          uom: x.uom,
          price: x.price,
          pricePerUnit: x.pricePerUnit,
          priceCurrency: x.priceCurrency,
          pricingUnitOfMeasure: x.pricingUnitOfMeasure,
          pricingPackageSize: x.pricingPackageSize,
          isFavorite: x.isFavorite,
          deliveryDate: x.desiredDelDate,
          quantity: x.orderQty,
          lineErrors: { 'rowId': rowId, 'errors': [] },
          orderConvFactor: x.uom == 'IB' ? x.orderConvFactor : 1,
          modifiedOrderedQuantity: x.uom == 'IB' ? x.orderConvFactor : 1,
          modifiedOrderingUOM: x.uom == 'IB' ? x.orderUOM : x.uom,
          modifiedUOMConverted: x.modifiedUOMConverted,
          pricingQuantity: x.pricingUnitConvFactor,
          pricingUnitConvFactor: x.pricingUnitConvFactor,
          orderType: x.orderType,
          omniumBP: x.omniumBp,
          successfullyProcessed: x.successfullyProcessed,
          supplierNumber: x.supplierNumber,
          errorMessage: x.errorMessage,
          yourPrice: x.yourPrice,
          paymentTerms: x.paymentTerms,
          totalGallon: null,
        };

        if (x.gallonConvFactor == null || newRow.quantity == '' || newRow.quantity == 0) {
          newRow.totalGallon = null;
        }
        else {
          newRow.totalGallon = (+x.gallonConvFactor * +(newRow.quantity));
        }

        this.qtyCount = this.qtyCount + x.orderQty;
        this.totalPrice = this.totalPrice + (x.orderQty * x.price);
        orderList.splice(orderList.length, 0, newRow);
      }
    });

    this.filteredDataCount = orderList.length;
    this.sroProductItemsDataSource.data = orderList;
    this.sroOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
    this.validateDeliveryDateFilter();
    this.enableResubmitOrder();

    if (this.sroProductItemsDataSource.data.length > 0) {
      this.disablecheckbox = false;
    }
    else {
      this.disablecheckbox = true;
    }
  }

  // Enable/Disable Resubmit Order Button
  enableResubmitOrder() {
    if (this.readOnlyAccess) {
      this.isResubmitOrderEnable = false;
    }
    else {
      if (this.sroOriginalProductItemsDataSource && this.sroOriginalProductItemsDataSource.length > 0 && this.shipToAccount
        && (!this.isNotValid)) {
        this.isResubmitOrderEnable = true;
      }
      else {
        this.isResubmitOrderEnable = false;
      }
    }
  }

  // Enable/Disable Save Button After Deleting products
  toggleSaveDeletedItems(toggle: boolean) {
    if (this.readOnlyAccess) {
      this.isSaveDeletedItemsEnable = false;
    }
    else {
      this.isSaveDeletedItemsEnable = toggle;
    }
  }

  // Show/Hide Product Detail section
  showDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();
  }

  // Show/Hide Product Detail information
  showProductDetails(item) {
    item.isProductDetailDisplayed = !item.isProductDetailDisplayed;
  }

  // Load master data
  loadMasterData() {
    this.loaderService.setLoaderStatus(true);

    // get sro Item Number List
    this.sraOrdersService.getItemNumberList().subscribe((result: any[]) => {
      this.itemNoList = result;
    });

    // get sro Ship To Facility List
    const getShipToFacility = this.sraOrdersService.getShipToFacilityList();
    forkJoin(getShipToFacility).subscribe((result: any[]) => {
      this.shipToFacilityList = result[0];
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false));
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Enable/Disable All Checkbox in the grid header
  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.sroProductItemsDataSource.data.forEach(x => {
        x.isSelected = true;
      });
      this.selectedCount = this.sroProductItemsDataSource.data.length;
    }
    else {
      this.showTabs = false;
      this.sroProductItemsDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.selectedCount = 0;
    }
    const checked = this.sroProductItemsDataSource.data.filter(x => x.isSelected == true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
    }
  }

  // Grid Row Checkbox in the grid row
  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.selectedCount = this.selectedCount + 1;
      const checked = this.sroProductItemsDataSource.data.filter(x => x.isSelected == false);
      if (checked && checked.length == 0) {
        this.allChecked = true;
      }
      else {
        this.allChecked = false;
      }
    }
    else {
      this.selectedCount = this.selectedCount - 1;
      this.allChecked = false;
      const checked = this.sroProductItemsDataSource.data.filter(x => x.isSelected == true);
      {
        if (checked && checked.length == 0) {
          this.showTabs = false;
        }
      }
    }
    const checked = this.sroProductItemsDataSource.data.filter(x => x.isSelected == true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
    }
  }

  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  // get total product count
  getTotalProductCount() {
    return this.sroProductItemsDataSource.data.length;
  }

  // set favorite
  selectForFavorite(element) {
    const isFavorite = element.isFavorite;
    if (element.isFavorite) {
      element.isFavorite = false;
    }
    else {
      element.isFavorite = true;
    }
    this.sraOrdersService.saveProductForfavorite(element.itemId, isFavorite).subscribe((result: any) => {
      element.isFavorite = result.item1;
      if (result.item2 == 1) {
        const dialog = this.matDialog.open(DialogComponent, {
          data: {
            title: 'Maximum limit for favorite items has been reached.', content: ''
          }
        });
        dialog.addPanelClass('max-limit-pop');
      }
    });
  }

  // change event of Ship To account Dropdown
  getShipTo(event) {
    if (event) {
      this.loaderService.setLoaderStatus(true);
      this.sraOrdersService.getDeliverToFacilityList(event.accountNumber, event.parentNumber).subscribe((result: any[]) => {
        this.deliverToList = result;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false));

      this.sraOrdersService.getSoldToFacility(event.accountNumber).subscribe((result: any[]) => {
        this.soldToFacility = [result];
        this.soldToAccount = this.soldToFacility[0].accountNumber;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false));

      this.shipToAccountName = event.accountName;
      this.isAddProductEnable = true;   // Enable Add Product Button
    } else {
      this.deliverToList = null;
      this.deliverToAccount = null;
      this.soldToFacility = null;
      this.soldToAccount = null;
      this.isAddProductEnable = false;   // Disable Add Product Button
      this.disablecheckbox = true;
    }
    this.errorMsgs = new Array();
    this.showErrorBlock = false;
    this.editToolKit = false;
    this.showTabs = false;
  }

  // change event of Deliver To account Dropdown
  getDeliverTo($event) {
    if ($event) {
      this.isAddProductEnable = true;   // Enable Add Product Button
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { sroDeliverToValue: true });
    }
  }

  // header controls value change event to enable save button
  hasHeaderInfoChanged(fieldName) {
    if (fieldName && this.shipToAccount) {
      this.isAddProductEnable = true;   // Enable Add Product Button
      switch (fieldName) {
        case 'PO':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { sroPOValue: true });
          break;
        case 'Special Instructions':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { sroSplInsValue: true });
          break;
        case 'Instruction Type':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { sroInsTypeValue: true });
          break;
        case 'Customer Pickup':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { sroCustPickupValue: true });
          break;
        case 'Email Address':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { sroEmailAddressValue: true });
          break;
      }
    }
  }

  // Edit Tool kit's Delivery Date validation
  validateDeliveryDateFilter() {
    const currentDate = new Date();
    this.config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    this.datemodel = this.configDate.getToday();
    this.tabNode = '';
  }

  // Edit Tool kit's buttons (Delivery Date and Delte Button functionality)
  SetAllFields(field: string, value: any) {
    switch (field) {
      case 'delete':
        if (value == true) {
          const refreshData = [];
          this.sroProductItemsDataSource.data.forEach(item => {
            if (item.isSelected) {
              this.itemsToDelete.push(item);
              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { sroPOValue: true });
              refreshData.push(item.itemId);
              this.selectedCount = this.selectedCount - 1;
              item.isSelected = false;
            }
          });

          // var filterDataAfterDeletion = this.sroProductItemsDataSource.data.filter(x => !refreshData.includes(x.itemId));
          const filterDataAfterDeletion = this.sroProductItemsDataSource.data.filter(x => refreshData.indexOf(x.itemId) == -1);
          if (filterDataAfterDeletion.length < 1) {
            this.disablecheckbox = true;
          }
          this.sroProductItemsDataSource = new MatTableDataSource(filterDataAfterDeletion);
          this.sroOriginalProductItemsDataSource = JSON.parse(JSON.stringify(this.sroProductItemsDataSource.data));
          this.enableResubmitOrder();
          this.toggleSaveDeletedItems(true);
        }
        this.setCount();
        this.tabNode = '';
        this.enableAllCheckBoxes(false);
        this.selectedCount = 0;
        this.editToolKit = false;
        this.showTabs = false;
        this.showErrorBlock = false;
        break;

      case 'deliverydate':
        this.sroProductItemsDataSource.data.forEach(item => {
          if (item.isSelected) {
            this.validateDate(item);
            item.deliveryDate = new Date(value.year, value.month - 1, value.day);
            this.selectedCount = this.selectedCount - 1;
            item.isSelected = false;
          }
        });

        this.sroOriginalProductItemsDataSource = JSON.parse(JSON.stringify(this.sroProductItemsDataSource.data));
        this.setCount();
        this.enableAllCheckBoxes(false);
        this.selectedCount = 0;
        this.validateDeliveryDateFilter();
        this.showTabs = false;
        this.editToolKit = false;
        break;
      default:
        break;
    }
  }

  // Date validation
  validateDate(productItem: any) {
    const oldProductLineValue = JSON.parse(JSON.stringify(this.sroOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldsroDateValue: oldProductLineValue.deliveryDate, newsroDateValue: productItem.deliveryDate });
    if (productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0) {
      this.validateLineItem(productItem);
    }
    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enableResubmitOrder();
  }

  // Resubmit Order button click
  resubmitOrder() {
    $('#cppOrderView').animate({ scrollTop: 0 }, 'slow');
    const saveObj: any = {};
    saveObj.cPPOrderId = this.orderId;
    saveObj.webOrderNumber = this.webOrderNumber;
    saveObj.companyCode = this.headerCompany;
    saveObj.shipToAccountId = this.shipToAccount;
    saveObj.deliverToId = this.deliverToAccount;
    saveObj.soldToId = this.soldToAccount;
    saveObj.purchaseOrderNumber = this.purchaseOrder;
    if ((this.specialInstructionText && (this.specialInstructionText.trim() != ''))) {
      // this.toastrService.error("Instruction Type is required with special instructions.");
      // return false;
      saveObj.instructionType = 41;// this.instructionType;
    }
    saveObj.instructionType = this.instructionType;
    saveObj.headerText = this.specialInstructionText;
    saveObj.emailAddress = this.accountEmail;
    saveObj.customerPickUp = this.isCustomerPickup;
    // this.clearAllFilter();
    saveObj.cppProductList = this.sroProductItemsDataSource.data;

    saveObj.cppProductList.forEach(x => {
      x.deliverydate = (new Date(x.deliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
      x.modifiedOrderedQuantity = x.orderConvFactor * x.quantity,
        x.pricingQuantity = x.pricingUnitConvFactor * x.quantity;
    });

    if (this.validateOrder()) {
      this.loaderService.setLoaderStatus(true);
      this.sraOrdersService.resubmitOrder(saveObj).subscribe((result: any) => {
        if (result) {
          let status = '';
          if (result.containsErrorSplit) {
            status = status + 'Order#: ' + result.webOrderNumber + ' - ' + result.splitId + result.errorList;
            this.toastrService.error(status);
          }
          else {
            status = status + 'Order#: ' + result.webOrderNumber + ' resubmitted successfully.';
            this.toastrService.success(status);
            this.sraOrdersService.setSroRequestId(0,true);
            this.sraOrdersService.webOrderNumberAndSplitId = result.webOrderNumber + '~' + 0 + '~ ';
            this.cppService.setCppOrderId(0);
            this.cppService.webOrderNumberAndSplitId = result.webOrderNumber + '~' + 0 + '~ ';
            this.cppService.redirectFromSra = 'sra-orders';
            this.router.navigate(['/sra/sra-order-summary']);
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, (error) => {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Order not saved in the system.');
      });
    }
  }

  // save deleted items to database
  saveDeletedItems() {
    const saveObj: any = {};
    saveObj.sroOrderId = this.orderId;
    saveObj.webOrderNumber = this.webOrderNumber;
    saveObj.companyCode = this.headerCompany;
    saveObj.shipToAccountId = this.shipToAccount;
    saveObj.deliverToId = this.deliverToAccount;
    saveObj.soldToId = this.soldToAccount;
    saveObj.purchaseOrderNumber = this.purchaseOrder;
    if ((this.specialInstructionText && (this.specialInstructionText.trim() != ''))) {
      // this.toastrService.error("Instruction Type is required with special instructions.");
      // return false;
      saveObj.instructionType = 41;// this.instructionType;
    }
    saveObj.instructionType = this.instructionType;
    saveObj.headerText = this.specialInstructionText;
    saveObj.emailAddress = this.accountEmail;
    saveObj.customerPickUp = this.isCustomerPickup;
    // this.clearAllFilter();
    saveObj.sroProductList = this.itemsToDelete;
    this.loaderService.setLoaderStatus(true);
    this.sraOrdersService.deleteOrderItems(saveObj).subscribe((result: any) => {
      if (result) {
        let status = '';
        status = this.itemsToDelete.length + 'Item(s)  Deleted successfully.';
        this.toastrService.success(status);
        if (this.sroProductItemsDataSource.data.length <= 0) {
          this.sraOrdersService.setSroRequestId(0, true);
          this.router.navigate(['/sro/error/order-maintenance-dashboard']);
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
        }
        else {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
        }
        this.loaderService.setLoaderStatus(false);
        this.toggleSaveDeletedItems(false);
      }
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Error Occured while deleting the Item.');
      this.toggleSaveDeletedItems(false);
      this.sraOrdersService.setSroRequestId(0, true);
      this.router.navigate(['/sro/error/order-maintenance-dashboard']);
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
    });
  }

  // validation on Resubmit Order
  validateOrder() {
    let isValidated = true;
    if (this.sroProductItemsDataSource.data && this.sroProductItemsDataSource.data.length > 0) {
      isValidated = true;
      this.sroProductItemsDataSource.data.forEach(x => {
        x = this.validateLineItem(x);
        if (x.lineErrors.errors.length > 0) {
          this.errorMsgs.push(x.lineErrors);
          this.getCommonErrors(this.errorMsgs);
          isValidated = false;
        }
      });
    }
    return isValidated;
  }

  // Line item validation
  validateLineItem(item: any) {
    if (item.quantity <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      item.lineErrors.errors.push({ id: 'quantity', error: 'Quantity should be greater than zero' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }
    const currentDate = (new Date()).toLocaleDateString('en-US').replace(/\u200E/g, '');
    if (item.deliveryDate == null || item.deliveryDate == '') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDate');
      item.lineErrors.errors.push({ id: 'deliveryDate', error: 'Requested Arrival Date is required.' });
    }
    else if (Date.parse((new Date(item.deliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '')) < Date.parse(currentDate)) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDate');
      item.lineErrors.errors.push({ id: 'deliveryDate', error: 'Requested Arrival Date should be greater than equal to current date.' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDate');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    return item;
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#cppOrderView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#cppOrderView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#cppOrderView').scrollTop = 0;
      $('#cppOrderView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.sroOriginalProductItemsDataSource.length > 0 && this.sroProductItemsDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.sroOriginalProductItemsDataSource.filter(x => x.rowId == element.rowId)[0];

        // get current object index
        const currentLineIndex = this.sroProductItemsDataSource.data.findIndex(x => x.rowId == element.rowId);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.sroProductItemsDataSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.sroProductItemsDataSource.data = this.sroProductItemsDataSource.data;

          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != oldLineValue.rowId);

          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.rowId);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        this.sroProductItemsDataSource.data = JSON.parse(JSON.stringify(this.sroOriginalProductItemsDataSource));

        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Dealer unit change and validation
  sroUnitChange(action: string, productItem: any) {
    if (action == 'decrease') {
      const decValue = +productItem.quantity - 1;
      if (decValue > 0) {
        productItem.quantity = decValue;
      }
      else {
        productItem.quantity = 1;
      }
    }
    else {
      productItem.quantity = +productItem.quantity + 1;
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.sroOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldsroQtyValue: oldProductLineValue.quantity, newsroQtyValue: productItem.quantity });
    if (productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0) {
      this.validateLineItem(productItem);
    }
    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enableResubmitOrder();
  }

  // Qty change on text change
  quantityTextChange(productItem) {
    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.sroOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldsroQtyValue: oldProductLineValue.quantity, newsroQtyValue: productItem.quantity });
    if (productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0) {
      this.validateLineItem(productItem);
    }

    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enableResubmitOrder();
  }

  // Grid columns count and Total display
  setCount() {
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    this.filteredDataCount = this.sroProductItemsDataSource.data.length;
    this.sroProductItemsDataSource.data.forEach(x => {
      this.qtyCount = this.qtyCount + +(x.quantity);
      this.totalPrice = this.totalPrice + (x.quantity * x.price);
    });
  }

  // redirect to Error maintenance dashboard
  navigateToDashboardPage() {
    this.router.navigate(['/sro/error/order-maintenance-dashboard']);
  }

  // On page destroy
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
  }

  // Business Rule Analysis pop-up Dialog display
  openBusinessRuleAnalysisDialog() {
    const dialogConfig = new MatDialogConfig();
    this.sroProductItemsDataSource.data.webNum = this.webOrderNumber;
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      gridData: Object.assign([], this.sroProductItemsDataSource.data)
    };

    this.matDialog.open(CppBusinessRuleAnalysisDialogComponent, dialogConfig);
  }
}
